// packages/components/src/support-ai/SimulationStarter.tsx
import React from 'react';
import { Button, Card } from '@dopomogai/ui';
import { PlayCircle } from 'lucide-react';

/**
 * Props for the SimulationStarter component.
 */
interface SimulationStarterProps {
  /** The main title of the scenario, e.g., "Sales Upsell Scenario" */
  scenarioTitle: string;
  /** A brief description of the simulation context. */
  scenarioDescription: string;
  /** The text for the main action button. */
  buttonText?: string;
  /** The function to call when the simulation is started. */
  onStart: () => void;
}

/**
 * A component that displays a welcome screen for a demo scenario,
 * prompting the user to begin the simulation.
 */
export const SimulationStarter: React.FC<SimulationStarterProps> = ({
  scenarioTitle,
  scenarioDescription,
  buttonText = 'Start Simulation',
  onStart,
}) => {
  return (
    <div className="flex items-center justify-center h-full p-8 bg-slate-50">
      <Card noHoverEffect className="w-full max-w-lg text-center">
        <div className="p-8">
          <div className="flex justify-center mb-5">
            <div className="p-4 bg-slate-100 rounded-xl border-2 border-black">
              <PlayCircle size={32} className="text-slate-700" />
            </div>
          </div>
          <h2 className="text-xl font-bold text-slate-900">{scenarioTitle}</h2>
          <p className="mt-2 text-sm text-slate-600 max-w-md mx-auto">
            {scenarioDescription}
          </p>
          <div className="mt-8">
            <Button
              text={buttonText}
              onClick={onStart}
              variant="primary"
              size="lg"
            />
          </div>
        </div>
      </Card>
    </div>
  );
};